<div class="heading has-image sorry-message">
  <div class="heading-trans">
      <div class="container">
          <div class="heading-copy pt-4">
              <h2 class="mb-0">Sorry, we're having a few problems at the moment</h2>
              <h5 class="my-4">We’re having a few problems at the moment, so we can’t continue on with your pre-approval. Don’t worry, we’re aware of this issue and we’re working to fix it as soon as possible. </h5>
          </div>
      </div>
  </div>
</div>

